// extracted by mini-css-extract-plugin
module.exports = {"Column":"Column_Column__dYbDE","HeaderImage":"Column_HeaderImage__3gmQZ","Header":"Column_Header__ZcoIt","Content":"Column_Content__38RwL"};